<div class="notes-component">
  <table mat-table [dataSource]="dataSource" matSort class="mb-4">

    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>
        Date
      </th>
      <td mat-cell *matCellDef="let element">
        <div fxLayout="column">
          <div class="title">{{element.DateGenerated | date:'dd/MM/yyyy'}}</div>
          <div class="description">
            {{element.DateGenerated | date:'h:mm a'}}
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="user">
      <th mat-header-cell *matHeaderCellDef>
        User
      </th>
      <td mat-cell *matCellDef="let element">
        {{element.Name}}
        @if(element.creditNote) {
          <div class="description">Credit</div>
        }
      </td>
    </ng-container>


    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef>
        Note
      </th>
      <!-- Only internal staff can see the notes where visibleToInternalStaff  = 1. All other can only see
      the notes where visibleToInternalStaff  = 0 -->
      <td mat-cell *matCellDef="let element">
        @if(element.DocumentConditionDetail){
          <div class="description mb-2">{{element.DocumentConditionDetail}}</div>
        }
        @if(element.Title){
          <div class="note-title">{{element.Title}}</div>
        }

        <div [ngClass]=" element.visibleToInternalStaff  == false ?  'class2' : 'class1'">
          <collapsable-expandable-text [value]="element.Note" [threshold]="60"></collapsable-expandable-text>
        </div>
        @if(element.visibleToInternalStaff){
          <div class="description mt-2">Internal only</div>
        }
        @if(element.NotificationSubmitter){
          <div class="description mt-2">{{element.NotificationSubmitter}}</div>  
        }
        
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <div class="actions" fxLayout="row" fxLayoutAlign="start center">
          @if (canEdit(element)) {
            <span class="mdi mdi-pencil-outline cursor-pointer" matTooltip="Edit" (click)="onEdit(element)"></span>
          }
          @if (element.UserId === user.UserId || isAdmin(user)) {
            <span class="mdi mdi-trash-can-outline cursor-pointer" matTooltip="Delete" (click)="onDelete(element)"></span>
          }
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  @if (total) {
    <app-custom-paginator [length]="total" [pageIndex]="offset" [pageSize]="limit"
    [pageSizeOptions]="[10, 20, 25, 50, 100]" (page)="onPagination($event)"></app-custom-paginator>
  }

  @if (total<1) {
    <table>
      <tr>
        <td class="not-found"> No notes found</td>
      </tr>
    </table>
  }
</div>
